/* Edstrøms – kollektionsside. Sortering, filtre og mobil-toggle (server-side via URL). */
(function () {
  function init() {
    var sort = document.getElementById('eds-sort');
    if (sort && !sort.dataset.bound) {
      sort.dataset.bound = '1';
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    var form = document.getElementById('eds-filters');
    if (form && !form.dataset.bound) {
      form.dataset.bound = '1';
      var timer;
      var submit = function () { form.requestSubmit ? form.requestSubmit() : form.submit(); };
      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') return; // pris: vent på blur
        clearTimeout(timer);
        timer = setTimeout(submit, 250);
      });
      form.querySelectorAll('input[type="number"]').forEach(function (inp) {
        inp.addEventListener('blur', submit);
      });
      // Fjern tomme felter fra URL'en
      form.addEventListener('submit', function () {
        form.querySelectorAll('input').forEach(function (i) { if (i.value === '') i.disabled = true; });
      });
    }

    var toggle = document.getElementById('eds-filter-toggle');
    if (toggle && form && !toggle.dataset.bound) {
      toggle.dataset.bound = '1';
      toggle.addEventListener('click', function () {
        var open = form.classList.toggle('open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
